import { withType } from "../../../utils/actionOperations";
import { RENDER_PDF_REPORT_PAGE_COUNT } from "../../constants";

export const reportPageCount = (sectionKey, count) => {
  return (dispatch) => {
    dispatch(withType(RENDER_PDF_REPORT_PAGE_COUNT, { sectionKey, count }));
  };
};
